import { useState } from 'react';

const AddTeplarPrintPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showAddTeplarPopup, setShowAddTeplarPopup] =
      useState<boolean>(false);

    const addToggleHandler = (show?: boolean) => {
      setShowAddTeplarPopup((prev) =>
        typeof show === 'boolean' ? show : !prev
      );
    };

    return (
      <Component
        showAddTeplarPopup={showAddTeplarPopup}
        addToggleHandler={addToggleHandler}
        {...props}
      />
    );
  };

export default AddTeplarPrintPopupHOC;
